import moment from 'moment';

export function utcToLocalTime(
    utcTime: string | null | undefined,
    fallback = '-- geen tijdstempel --'
): string {
    if (utcTime) {
        return moment.utc(utcTime).local().format('DD-MM-YYYY HH:mm:ss');
    } else {
        return fallback;
    }
}
